import { defineMessages } from "react-intl"

export const visibilityFieldMessages = defineMessages({
	marketToCustomersDisabled: {
		defaultMessage: "Unlisted",
		id: "visibility.marketToCustomers.disabled",
	},
	marketToCustomersDisabledDescription: {
		defaultMessage: "The listing is available to anyone who has the link",
		id: "visibility.marketToCustomers.disabled.description",
	},
	marketToCustomersDisabledHint: {
		defaultMessage: "Subsidized service loaner which are still in use cannot be published to customers.",
		id: "visibility.marketToCustomers.inUseSubsidizedServiceLoaner.disabledHint",
	},
	marketToCustomersEnabled: {
		defaultMessage: "Public",
		id: "visibility.marketToCustomers.enabled",
	},
	marketToCustomersEnabledDescription: {
		defaultMessage: "The listing can be found in the public vehicle search",
		id: "visibility.marketToCustomers.enabled.description",
	},
	marketToCustomersLabel: {
		defaultMessage: "Set visibility",
		id: "visibility.marketToCustomers.label",
	},
	onlineOrderingDisabled: {
		defaultMessage: "Disabled",
		id: "visibility.onlineOrdering.disabled",
	},
	onlineOrderingEnabled: {
		defaultMessage: "Enabled",
		id: "visibility.onlineOrdering.enabled",
	},
	onlineOrderingEnabledLabel: {
		defaultMessage: "Online ordering",
		id: "visibility.onlineOrdering.label",
	},
	title: {
		defaultMessage: "Listing settings",
		id: "visibility.title",
	},
})
